import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, reactive } from 'vue';
export default {
  __name: 'RegisterArea',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, " 注册地要求 ");
    };
  }
};